import { JBaseApi } from '../base';
import { ApiWrapper, WidgetLuccaAbsenceUser } from '../../types';
import { OF } from '../../util';
export class JLuccaApi extends JBaseApi {
    public async getAbsence(
        payload: { date?: string },
        params?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<WidgetLuccaAbsenceUser[]>> {
        return this.network.post(
            {
                o: 'lucca',
                f: 'getAbsence',
                ...payload,
            } as OF,
            params?.signal,
        );
    }
}
